// extracted by mini-css-extract-plugin
export var content = "ClubBanner-module--content--t1MX0";
export var contentSection = "ClubBanner-module--contentSection--rx4oR";
export var imageTitle = "ClubBanner-module--imageTitle--OJ5R-";
export var imageWrapper = "ClubBanner-module--imageWrapper--JLtB-";
export var label = "ClubBanner-module--label--3BGTl";
export var title = "ClubBanner-module--title--VeJxc";